'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotOhlcIcon = function PlotOhlcIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M6.688 2.688h2.625v26.625H6.688zm2.625 12h5.375v2.625H9.313zm-8 8h5.375v2.625H1.313zm20-20h2.688v26.625h-2.688zm-5.313 4h5.313v2.625H16zm8 10.625h5.313v2.688H24z' })
    );
};

exports.default = PlotOhlcIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotOhlcIcon.js
// module id = 672
// module chunks = 0